import { PayloadAction } from '@reduxjs/toolkit';

import { StationsState } from '../../types';
import { Station } from 'dataSources/Typicode/stations';

export const removeSelectedStationOnRoute = (state: StationsState, action: PayloadAction<Station['code']>) => {
  state.selectedStation.data = (state.selectedStation.data || []).filter((code) => code !== action.payload);
};
